import { Linkedin, Award } from "lucide-react";
import { FOUNDERS, MISSION, DPIIT } from "../data/mock";
import { useInView } from "../hooks/useInView";

export const FoundersSection = () => {
  const [ref, isInView] = useInView();
  return (
    <section id="about-teaser" className="py-16 lg:py-20 bg-white relative overflow-hidden">
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-sky-50/40 rounded-full blur-3xl pointer-events-none" />
      <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8 relative" ref={ref}>
        <div className="text-center max-w-3xl mx-auto mb-10">
          <span className="inline-block text-sm font-semibold text-sky-600 tracking-wider uppercase mb-4">
            Our Mission
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight mb-5">
            {MISSION.headline}
          </h2>
          <p className="text-slate-500 leading-relaxed">{MISSION.body}</p>

          {/* DPIIT badge */}
          <div className="inline-flex items-center gap-3 mt-6 px-4 py-2.5 rounded-2xl bg-gradient-to-r from-orange-50 via-white to-green-50 border border-orange-200/60" data-testid="dpiit-badge">
            <Award className="w-5 h-5 text-orange-500" />
            <div className="text-left">
              <p className="text-xs font-bold text-slate-900">{DPIIT.label}</p>
              <p className="text-[10px] text-slate-500">{DPIIT.number} · {DPIIT.fullLabel}</p>
            </div>
          </div>
        </div>

        {/* Founders */}
        <div className={`grid sm:grid-cols-2 gap-5 max-w-3xl mx-auto transition-all duration-700 ${isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {FOUNDERS.map((f, i) => (
            <div
              key={i}
              className="relative bg-white rounded-3xl border border-slate-200 hover:border-sky-300 p-5 sm:p-6 transition-colors shadow-sm hover:shadow-md"
              data-testid={`founder-card-${i}`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-sky-500 to-sky-700 flex items-center justify-center text-white text-lg font-extrabold flex-shrink-0">
                  {f.initials}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-sky-600 font-semibold uppercase tracking-wider">{f.role}</p>
                  <h3 className="text-lg font-bold text-slate-900 mt-0.5 truncate">{f.name}</h3>
                  <p className="text-sm text-slate-600 mt-1">{f.creds}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{f.previously}</p>
                  <a
                    href={f.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 mt-3 text-xs font-semibold text-sky-600 hover:text-sky-700"
                    data-testid={`founder-linkedin-${i}`}
                  >
                    <Linkedin className="w-3.5 h-3.5" />
                    LinkedIn
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
